import { VFC, useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Orientation } from '@enmon/commons';
import { Select } from '../Select';
import { MeterDetails as messages } from '../../Form/meter_details/messages';
import { orientationTranslated } from '../../Form/meter_details/constants';
import { useMeterModelSuggestionsStore } from '../../../store/useMeterModelSuggestionsStore';
import { getSelectOptionsWithSuggestions } from '../utils/getSelectOptionsWithSuggestions';

interface OrientationSelectProps {
  value?: Orientation;
  onChange?: (value: Orientation) => void;
}

export const OrientationSelect: VFC<OrientationSelectProps> = ({ ...restProps }) => {
  const intl = useIntl();
  const { meterModelSuggestions } = useMeterModelSuggestionsStore();

  const orientationOptions = useMemo(
    () =>
      getSelectOptionsWithSuggestions({
        intl,
        values: Object.values(Orientation),
        suggestedValue: meterModelSuggestions?.orientation?.value,
        suggestedSelection: meterModelSuggestions?.orientation?.selection,
        labelFormatter: (value: Orientation) => intl.formatMessage(orientationTranslated[value]),
      }),
    [meterModelSuggestions, intl],
  );

  return (
    <Select
      allowClear
      showArrow
      className="w-100"
      options={orientationOptions}
      placeholder={<FormattedMessage {...messages.orientationPlaceholder} />}
      {...restProps}
    />
  );
};
